import {DescriptionItem, DescriptionList} from "../components/DescriptionList";
import {RichMessageText, TokenSpan} from "../diagnostics/RichMessageText";
import type {ObjectRef, RichMessage} from "../diagnostics/types";

export interface DecisionMessageProps {
  message: RichMessage;
  expanded?: boolean;
  canNavigate?: (ref: ObjectRef) => boolean;
  onNavigate?: (ref: ObjectRef) => void;
}

/** Shared decision prose and evidence; the host owns navigation and expansion. */
export const DecisionMessage = ({message, expanded = false, canNavigate, onNavigate}: DecisionMessageProps) => <div className="space-y-2 text-sm leading-5">
  <p><RichMessageText message={message} canNavigate={canNavigate} onNavigate={onNavigate} /></p>
  {expanded && message.detail && <p className="text-[var(--ots-text-muted)]"><RichMessageText message={message} expanded canNavigate={canNavigate} onNavigate={onNavigate} /></p>}
  {expanded && !!message.facts?.length && <DescriptionList className="gap-2">
    {message.facts.map((fact, index) => <DescriptionItem key={index} label={fact.label ?? "Supporting input"}>
      <TokenSpan token={fact.value} canNavigate={canNavigate} onNavigate={onNavigate} />
    </DescriptionItem>)}
  </DescriptionList>}
</div>;
